// Terms of use, Simplified Chinese. Translation of en.js: keep the same blocks in the same order.
const terms = {
  "ui": {
    "back": "返回 Luckblocks",
    "eyebrow": "法律",
    "title": "使用条款",
    "updated": "最后更新：2026 年 11 月 1 日。"
  },
  "blocks": [
    {
      "tag": "p",
      "html": "<strong>使用条款 - LUCKBLOCKS</strong>"
    },
    {
      "tag": "p",
      "html": "<strong>1. 条款的接受</strong>"
    },
    {
      "tag": "p",
      "html": "在使用与 <strong>LUCKBLOCKS</strong> 相关的任何服务或产品之前，您必须阅读并同意全部使用条款和条件。本条款和条件管辖并适用于网站 www.luckblocks.com（以下简称“<strong>LUCKBLOCKS</strong>”），我们据以向您提供服务的任何单独协议均受 <strong>帕劳 (PALAU)</strong> 法律管辖并依其解释。"
    },
    {
      "tag": "p",
      "html": "在网站 www.luckblocks.com 上注册并点击“同意”，即表示<strong>您作为用户</strong>（<strong>“您”；“您的”；“用户”；“玩家”</strong>）同意本使用条款以及下文所述的全部条款和条件，包括隐私政策及其他适用于本网站使用的政策或规则（“<strong>条款</strong>”）。因此，您正在与我们订立一项具有法律约束力的协议，您对本网站的使用和访问即表示您已阅读、理解并同意受本条款约束。请注意，一经同意，您的全部权利和义务即受其约束，因此上述要求和使用条件对于订立所请求的任何服务至关重要。"
    },
    {
      "tag": "p",
      "html": "<strong>因此，在接受之前，请确保您已理解并同意本使用条款和条件的全部内容。</strong>"
    },
    {
      "tag": "p",
      "html": "根据各国的最低法律规定，严禁未满 18（十八）岁的未成年人提交其个人数据或第三方数据，且未成年人不得使用或操作 <strong>LUCKBLOCKS</strong> 所提供或提议提供的任何服务。<strong>LUCKBLOCKS</strong> 无法核实本服务在各司法管辖区的合法性，确保本服务的使用合法是用户的责任。"
    },
    {
      "tag": "p",
      "html": "<strong>LUCKBLOCKS</strong> 及其许可方是本服务及其代码、结构和组织的全部权利（包括著作权、商业秘密、知识产权及其他权利）的唯一所有者。在 GNU General Public License (GPL) 的范围内，您可以自由使用本软件，但须以书面形式明确告知任何修改及其对项目的影响。您同意，因任何未经项目同意的未经授权和/或非法使用而产生的一切费用，均应立即告知 <strong>LUCKBLOCKS</strong>，LUCKBLOCKS 将根据所提供的信息，在开展的任何调查中提供合理协助。"
    },
    {
      "tag": "p",
      "html": "“<strong>LUCKBLOCKS</strong>”一词、其域名以及 <strong>LUCKBLOCKS</strong> 作为本服务一部分所使用的任何其他商标或服务标志（“商标”）均为 <strong>LUCKBLOCKS</strong> 的专有财产。此外，本网站上的全部内容，包括但不限于图像、照片、图形、摄影作品、动画、视频、音乐、音频和文字（“网站内容”），均归 <strong>LUCKBLOCKS</strong> 所有，并受著作权和/或其他知识产权或其他权利保护。您确认，使用本服务并不使您取得对网站内容和/或商标或其任何部分的任何权利。未经 <strong>LUCKBLOCKS</strong> 事先书面同意，您在任何情况下均不得使用网站内容和/或商标。此外，您同意不实施任何可能损害或潜在损害 <strong>LUCKBLOCKS</strong> 权利（包括知识产权）的行为。"
    },
    {
      "tag": "h4",
      "html": "<strong>2. 定义</strong>"
    },
    {
      "tag": "p",
      "html": "在本“<strong>使用条款 - LUCKBLOCKS</strong>”中，下列用语具有以下所赋予的含义："
    },
    {
      "tag": "p",
      "html": "<strong>a) 用户：</strong>已达法定年龄、具备行为能力并经适当身份识别的自然人或法人，在接受本使用条款后使用 LUCKBLOCKS 服务。"
    },
    {
      "tag": "p",
      "html": "<strong>b) 界面</strong>：LUCKBLOCKS 的应用程序、网站和服务渠道。"
    },
    {
      "tag": "p",
      "html": "<strong>c) 本网站</strong>：<a href=\"http://www.LUCKBLOCKS.com\">www.luckblocks.com</a>（<a href=\"https://LUCKBLOCKS.com/\">https://luckblocks.com/</a>）。"
    },
    {
      "tag": "p",
      "html": "<strong>d) 加密资产</strong>：基于密码学并登记于区块链网络上的数字资产。"
    },
    {
      "tag": "p",
      "html": "<strong>e) 区块链</strong>：一种先进的数据库，通过不允许篡改的一致性链条存储数据，记录使用加密资产进行的交易。"
    },
    {
      "tag": "p",
      "html": "<strong>f) 加密资产钱包</strong>或<strong>钱包</strong>：存储区块链上所存加密货币之访问信息的软件或设备。"
    },
    {
      "tag": "p",
      "html": "<strong>g) 私钥</strong>：仅由用户知晓的字母数字密钥，可用于恢复加密资产钱包，是唯一的恢复方式，应妥善保管，绝不可与第三方共享。"
    },
    {
      "tag": "p",
      "html": "<strong>h) IPFS（InterPlanetary File System，星际文件系统）</strong>：一种去中心化、分布式的网络协议，以点对点方式存储和检索文件，使用分布式计算机网络而非依赖中央服务器。这意味着界面上的文件并非存储于单一位置，而是分布在 IPFS 网络内的多个节点上。"
    },
    {
      "tag": "h4",
      "html": "<strong>3. 网站的使用</strong>"
    },
    {
      "tag": "p",
      "html": "3.1 <strong>LUCKBLOCKS</strong> 网站在 <a href=\"https://luckblocks.com\">www.luckblocks.com</a> 上提供，并在 IPFS 上设有副本；由于其使用区块链，网站可能偶尔出现错误、故障或暂时无法访问。用户理解并同意，使用本网站的风险由其自行承担，用户通过私钥完全保管其资产。用户同意就本网站提供反馈，包括错误报告、性能问题或任何其他有助于改进本网站的相关信息。"
    },
    {
      "tag": "p",
      "html": "3.2 <strong>LUCKBLOCKS 是构建于 Polygon 区块链上的一套去中心化游戏：以 BTC (WBTC)、ETH (WETH)、POL 和 CRANNI 支付奖金的抽奖彩票；以 USDT 支付奖金的 Bull vs Bear 和 BullsEye 预测游戏；以及以 CRANNI 支付奖金的 Cranni Bestiarium 动物游戏。LUCKBLOCKS 还提供流动性挖矿质押和 Cynths 合成资产。结果来自 Chainlink VRF v2.5（随机数）和 Chainlink 喂价，任何人均可在链上进行验证。</strong>"
    },
    {
      "tag": "p",
      "html": "<strong>为每日彩票购买的彩票同时也是同一代币每周彩票的一次参与。若某次开奖未达到最低奖池，彩票和奖金将滚存至下一次开奖。开奖、轮次和再平衡由已质押的 NFT 节点（Cranni Societas）在链上执行，节点每次执行均获得报酬。LUCKBLOCKS 通过智能合约运行，无需中心化维护，依据 GNU General Public License 开源，并设有 IPFS 版本以增强去中心化和抗审查能力。各游戏的规则见：<a href=\"https://docs.luckblocks.com/\">https://docs.luckblocks.com/</a></strong>"
    },
    {
      "tag": "h4",
      "html": "<strong>4. 责任限制</strong>"
    },
    {
      "tag": "p",
      "html": "4.1 用户理解并同意，<strong>LUCKBLOCKS</strong> 网站、提供该网站的官方社交渠道（Instagram：@luckblockscom，Telegram：@luckblockscom，Discord：<a href=\"https://discord.gg/NAnBqc4g\">https://discord.gg/NAnBqc4g</a>，X/Twitter：@luckblockscom）以及为其运行提供技术的第三方，均不对因使用或无法使用本应用程序而产生的任何直接、间接、附带、特殊、后果性或惩罚性损害承担责任。"
    },
    {
      "tag": "p",
      "html": "4.2 对于按“现状”向您提供的服务，<strong>LUCKBLOCKS</strong> 不作任何明示或默示的保证，亦不就其质量、对特定用途的适用性、完整性或准确性作出任何保证或陈述。无论 <strong>LUCKBLOCKS</strong> 作出何种努力，均不保证服务不会中断、及时或无错误，亦不保证缺陷将得到纠正。"
    },
    {
      "tag": "p",
      "html": "4.3 在任何情况下（包括过失），<strong>LUCKBLOCKS</strong> 均不对因使用或滥用本服务而产生的任何直接、间接、特殊、附带或后果性损害（包括营业利润损失、业务中断或商业信息丢失）承担责任，即使 <strong>LUCKBLOCKS</strong> 事先已知悉发生此类损害的可能性。"
    },
    {
      "tag": "p",
      "html": "4.4 本服务条款不排除或限制 <strong>LUCKBLOCKS</strong> 对因其过失造成的死亡或人身伤害所应承担的责任。"
    },
    {
      "tag": "p",
      "html": "4.5 用户保留对其加密资产的完全控制权。需要明确的是，<strong>LUCKBLOCKS</strong> 及任何关联实体均不是 Polygon 区块链底层区块链网络上任何交易的当事方；其对任何加密资产或用户资金不享有占有、保管或控制。您理解，在与 Polygon 区块链交互时，您始终保持对您加密资产的控制。"
    },
    {
      "tag": "p",
      "html": "4.6 用户使用第三方自托管钱包与 Polygon 协议进行交互；<strong>LUCKBLOCKS</strong> 对此类钱包不享有任何控制，亦不作任何保证。"
    },
    {
      "tag": "p",
      "html": "4.7 如需通过界面与 Polygon 区块链交互，须通过您的自托管钱包进行连接。必须了解的是，您的自托管钱包由第三方实体提供，通常受相应第三方服务提供商所制定的单独条款和条件管辖。"
    },
    {
      "tag": "p",
      "html": "4.8 上述条款和条件可能涉及额外费用、免责声明或关于所提供信息之准确性和可靠性的警示。"
    },
    {
      "tag": "p",
      "html": "4.9 审阅并理解与您所选自托管钱包提供商相关的条款和条件，以确保合规并知悉任何适用的费用或风险，完全是您自身的责任。"
    },
    {
      "tag": "p",
      "html": "4.10 <strong>LUCKBLOCKS</strong> 不是 Polygon 区块链上交易的中介。"
    },
    {
      "tag": "p",
      "html": "4.11 鉴于该技术的非托管和去中心化性质，<strong>LUCKBLOCKS</strong> 不是中介、代理人、顾问或托管人，对于您在使用我们的服务期间所作的任何其他决定或从事的任何其他活动，LUCKBLOCKS 与您之间不存在任何信义关系或信义义务。"
    },
    {
      "tag": "p",
      "html": "4.12 您确认，除区块链上公开可得的信息外，<strong>LUCKBLOCKS</strong> 不掌握有关 Polygon 区块链上交易的任何信息。但是，我们可能依据我们的隐私政策收集有关服务用户的信息。区块链可能产生相关费用。<strong>LUCKBLOCKS</strong> 并不掌握有关协议上全部交易的敏感信息，但区块链是公开且不可篡改的，因此在此之外提供的任何数据均可能被公开获取。"
    },
    {
      "tag": "p",
      "html": "4.13 使用区块链进行的交易可能需要支付 GAS 费，GAS 费本质上是就所选区块链网络上发生的每笔交易支付的网络交易费。请注意，GAS 费不予退还。<strong>LUCKBLOCKS</strong> 不向用户提供任何服务或产品，亦不交付、维护加密资产或收取加密资产付款。<strong>LUCKBLOCKS</strong> 仅允许用户购买彩票、在其游戏中投注以及使用其质押、节点和合成资产合约，相关费用已包含在内并在每笔交易前显示，亦可在以下网址查阅：<a href=\"https://docs.luckblocks.com\">https://docs.luckblocks.com</a>。"
    },
    {
      "tag": "p",
      "html": "4.14 界面的一份副本托管于星际文件系统（“IPFS”），这是一种去中心化、分布式的网络协议，以点对点方式存储和检索文件，使用分布式计算机网络而非依赖中央服务器。这意味着界面上的文件并非存储于单一位置，而是分布在 IPFS 网络内的多个节点上，因此，您理解界面托管于一个用于存储和访问数据及内容的去中心化基础设施上。"
    },
    {
      "tag": "p",
      "html": "4.15 您同意 <strong>LUCKBLOCKS</strong> 网站上所述的游戏规则，LUCKBLOCKS 保留对本服务之发行、维护和终止的决定权。<strong>LUCKBLOCKS</strong> 管理方就本服务的任何使用或争议解决所作的决定为最终决定，不受审查或上诉。"
    },
    {
      "tag": "h4",
      "html": "<strong>5. 费用与限额</strong>"
    },
    {
      "tag": "p",
      "html": "5.1 <strong>LUCKBLOCKS</strong> 不收取月费。费用仅按每笔交易收取：购买彩票、投注、铸造合成资产（0.5%，持有 888 枚或以上 CRANNI 的持有者免收）以及提前提取已质押的 LP 代币（存入后 7 天内提取收取 10%，发送至销毁地址）。"
    },
    {
      "tag": "p",
      "html": "5.2 <strong>LUCKBLOCKS</strong> 收取的全部费用金额均已整合并在购买表单中正式告知，最低金额和交易限额亦一并列明，相关信息可在 <strong>LUCKBLOCKS</strong> 网站上查阅；付款仅可使用加密资产。"
    },
    {
      "tag": "p",
      "html": "5.3 <strong>LUCKBLOCKS</strong> 保留随时单方面变更其产品、服务或第三方产品、服务或其适用价格的权利，且无需就此类变更事先通知。"
    },
    {
      "tag": "p",
      "html": "5.4 访问或使用 <strong>LUCKBLOCKS</strong> 服务的特定功能可能适用额外的条款和费用。"
    },
    {
      "tag": "h4",
      "html": "<strong>6. 关于 LUCKBLOCKS 的服务与政策</strong>"
    },
    {
      "tag": "p",
      "html": "6.1 遵守 <strong>LUCKBLOCKS</strong> 所提供的政策、条款和说明是用户的义务。"
    },
    {
      "tag": "p",
      "html": "6.2 您严格以个人及非职业身份参与游戏，仅出于休闲和娱乐目的。"
    },
    {
      "tag": "p",
      "html": "6.3 您确认，游戏旨在娱乐，但一小部分人可能在游戏时失去自控。必须理解的是，博彩不应被视为收入来源或偿还债务的方式。建议您关注每日在线上彩票中所花费的时间和金钱。"
    },
    {
      "tag": "p",
      "html": "6.4 您理解，参与游戏存在损失您存放于所选钱包中的虚拟资金的风险。"
    },
    {
      "tag": "p",
      "html": "6.5 在本合同有效期内向 <strong>LUCKBLOCKS</strong> 提供的全部信息均真实、完整、正确，如有任何变更，您必须立即通知 <strong>LUCKBLOCKS</strong>。"
    },
    {
      "tag": "p",
      "html": "6.6 对于从 <strong>LUCKBLOCKS</strong> 获得的任何奖金所涉及的任何适用税款，您独自负责申报和核算。"
    },
    {
      "tag": "p",
      "html": "6.7 您理解，比特币等虚拟资金不被视为货币或法定货币，因此在本网站上被视为不具有内在价值的虚拟资金。您理解，比特币的价值可能因市场价值而发生剧烈变化。"
    },
    {
      "tag": "p",
      "html": "6.8 可能出现购买被错误确认或付款被错误支付的情形。在所有此类情形下，<strong>LUCKBLOCKS</strong> 均不保留取消或退款的权利，因为所有交易均直接在区块链上进行，任何错误均不可逆转，无法退款。"
    },
    {
      "tag": "p",
      "html": "6.9 每日彩票可在其开奖前通过自动化机制放弃，该机制退还彩票价格的 75%（即损失 25%），并放弃该彩票的每周参与资格。"
    },
    {
      "tag": "p",
      "html": "6.10 如您知悉本网站存在任何潜在错误或遗漏，您必须避免利用该等错误或遗漏。此外，您同意立即向 <strong>LUCKBLOCKS</strong> 报告任何错误或遗漏。如您未履行本条所述义务，<strong>LUCKBLOCKS</strong> 有权就与该错误或遗漏相关的全部费用获得全额赔偿，包括因相应错误/遗漏以及未通过官方支持渠道直接通知而产生的任何费用。"
    },
    {
      "tag": "p",
      "html": "6.11 <strong>LUCKBLOCKS</strong> 禁止在其社交媒体、博客和服务渠道中传播任何诽谤性、冒犯性、不实、种族主义、性别歧视、恐同、色情、暴力、政治性、宣扬毒品、宣扬恐怖主义、宣扬洗钱、宣扬腐败或以其他方式违反法律、损害 <strong>LUCKBLOCKS</strong> 或第三方形象、或违背公序良俗的内容。"
    },
    {
      "tag": "p",
      "html": "6.12 <strong>LUCKBLOCKS</strong> 服务和产品的正常运行可能取决于第三方产品和服务（例如智能手机、平板电脑、个人电脑、区块链和电信服务）的兼容性和正常运行。"
    },
    {
      "tag": "p",
      "html": "6.13 如违反本服务条款的一项或多项规定，<strong>LUCKBLOCKS</strong> 保留采取一切适当措施的权利，包括在立即暂停之外终止合同并提起法律诉讼。"
    },
    {
      "tag": "p",
      "html": "6.14 您同意赔偿、抗辩并使 <strong>LUCKBLOCKS</strong> 及其股东、董事、代理人和员工免受因以下原因可能产生的一切索赔、要求、责任、损害、损失、成本和费用（包括律师费及任何其他费用，无论原因为何）：(i) 违反本服务条款；(ii) 违反任何法律或第三方权利；以及 (iii) 使用本服务。"
    },
    {
      "tag": "h4",
      "html": "<strong>7. LUCKBLOCKS 网站 - 一般规则</strong>"
    },
    {
      "tag": "p",
      "html": "7.1 为充分使用 <strong>LUCKBLOCKS</strong> 网站的各项功能，用户必须通过 WalletConnect (Reown AppKit) 或兼容的浏览器钱包连接自托管钱包。"
    },
    {
      "tag": "p",
      "html": "7.2 用户确认，<strong>LUCKBLOCKS</strong> 不保管任何性质的资产，<strong>LUCKBLOCKS</strong> 网站仅作为访问用户加密资产地址的界面以及与区块链之间的集成工具。"
    },
    {
      "tag": "p",
      "html": "7.3 用户确认，鉴于本网站所采用的区块链技术及所生成地址的安全特性，加密资产余额、私钥、助记词和安全词均无法恢复，因为 <strong>LUCKBLOCKS</strong> 或参与平台运营的第三方均不存有任何性质的记录。"
    },
    {
      "tag": "p",
      "html": "7.4 在购买彩票过程中，可能发生币价波动，<strong>LUCKBLOCKS</strong> 不提供任何补偿或价值补足。"
    },
    {
      "tag": "p",
      "html": "7.5 <strong>持有用户通过 LUCKBLOCKS 网站可能取得的加密资产，其本身不产生任何形式的收益、股息或报酬。LP 质押和 NFT 节点奖励仅来自玩家实际支付的费用，随平台活跃度而变化，且不作保证。这些加密资产的价值仅与其所属的区块链相关联。</strong>"
    },
    {
      "tag": "h4",
      "html": "<strong>8. 游戏规则 - 彩票：</strong>"
    },
    {
      "tag": "p",
      "html": "8.1 <strong>LUCKBLOCKS</strong> 允许购买抽奖彩票，每张彩票享有一次每日中奖机会，并额外享有一次每周模式的中奖机会，分配如下：您购买的每张彩票按以下方式分配："
    },
    {
      "tag": "ul",
      "items": [
        "47.5% 计入每日彩票奖池",
        "47.5% 计入每周彩票奖池",
        "4% 归 CRANNI-WPOL LP 质押者（流动性挖矿）；若购买者有推荐人，该部分中的 1% 归推荐人",
        "1% 归平台，平台亦以此支付 Chainlink VRF 请求费用"
      ]
    },
    {
      "tag": "p",
      "html": "执行开奖的 NFT 节点从该次开奖的头奖中获得报酬：每日头奖的 2%，每周头奖的 9.5%。"
    },
    {
      "tag": "p",
      "html": "8.2 彩票/抽奖共有四种选项，价格和难度各不相同："
    },
    {
      "tag": "ul",
      "items": [
        "BTC：彩票价格为 0.10 USDT，开奖最低奖池为 $25（20 USD 平台种子资金 + 5 USD 彩票收入），合约彩票 20 张。",
        "ETH：彩票价格为 0.20 USDT，开奖最低奖池为 $55（50 USD 平台种子资金 + 5 USD 彩票收入），合约彩票 10 张。",
        "POL：彩票价格为 0.30 USDT，开奖最低奖池为 $55（50 USD 平台种子资金 + 5 USD 彩票收入），合约彩票 5 张。",
        "<strong>CRANNI：</strong>彩票价格为 0.40 USDT，开奖最低奖池为 $155（150 USD 平台种子资金 + 5 USD 彩票收入），合约彩票 2 张。"
      ]
    },
    {
      "tag": "p",
      "html": "每周开奖要求头奖至少为 $20。彩票价格可通过治理进行调整，但绝不低于 0.10 USDT；当前价格始终在购买前于网站上显示。"
    },
    {
      "tag": "p",
      "html": "8.3 如 <strong>LUCKBLOCKS</strong> 合约赢得开奖，头奖将累积并按以下方式进行内部分配："
    },
    {
      "tag": "ul",
      "items": [
        "60% 计入下一次开奖的奖金",
        "20% 计入为未来最低奖池提供资金的储备",
        "20% 计入每周彩票奖金。"
      ]
    },
    {
      "tag": "p",
      "html": "8.4 在开奖前，每日彩票可被放弃，系统将自动退还彩票价格的 75%，并放弃其每周参与资格。更多信息请见：<a href=\"https://docs.luckblocks.com/\">https://docs.luckblocks.com/</a>"
    },
    {
      "tag": "p",
      "html": "8.5 Bull vs Bear 和 BullsEye 预测游戏以及 Cranni Bestiarium 有其各自的规则、费用和奖金表，公布于 <a href=\"https://docs.luckblocks.com/\">https://docs.luckblocks.com/</a> 并在各游戏页面上显示。参与上述游戏即表示您接受相关规则。部分国家对博彩类游戏有所限制，核实您是否可在居住地参与游戏是您的责任。"
    },
    {
      "tag": "h4",
      "html": "<strong>9. 奖励与激励政策</strong>"
    },
    {
      "tag": "p",
      "html": "9.1 NFTnodes，又称 Cranni Societas，是由对等方/节点组成的社区，在 <strong>LUCKBLOCKS</strong> 的运行中发挥关键作用。作为该 NFT 系列的持有者，他们负责在链上执行每一次开奖。为提供此项服务，Cranni Societas 持有者将其 NFT 质押于我们的智能合约中，并运行开源的 Node Manager（例如在 VPS 服务器上），Node Manager 加入各平台的节点队列，并在轮到其执行时执行相应任务。"
    },
    {
      "tag": "p",
      "html": "9.2 参与此项服务后，执行节点按上线时的数值获得：每日彩票头奖的 2%（Common NFTnodes）；每周彩票头奖的 9.5%（Golden NFTnodes）；每一轮 Bull vs Bear 和每一次 Cranni Bestiarium 开奖的 2%（Golden NFTnodes）；每一轮 BullsEye 的 2%（Common NFTnodes）；以及其清算的不安全 Cynths 头寸罚金的一部分。上述数值可通过治理进行调整。"
    },
    {
      "tag": "p",
      "html": "9.3 该模式是一种社区激励方式，同时确保本网站安全运行，无需开发者维护或中心化支持。"
    },
    {
      "tag": "p",
      "html": "9.4 NFTnodes 是 <strong>LUCKBLOCKS</strong> 生态系统不可分割的组成部分，为平台的彩票开奖提供去中心化且可靠的支持。"
    },
    {
      "tag": "p",
      "html": "9.5 CRANNI 代币持有者的激励。作为 CRANNI 代币持有者，您可以通过持有 CRANNI-WPOL LP 并在 luckblocks.com 的资金池 dapp 中质押，分享 <strong>LUCKBLOCKS</strong> 的成功。您将以 USDT 获得游戏实际收取费用的一部分。持有 888 枚或以上 CRANNI 代币的持有者购买所有彩票均可享受 20% 折扣，并可免费铸造合成资产。平台参数的变更（例如享受折扣所需的 CRANNI 代币数量）由已质押 NFT 节点的持有者通过链上治理决定。"
    },
    {
      "tag": "p",
      "html": "9.6 以稳定币奖励的去中心化资金池。<strong>LUCKBLOCKS</strong> 为流动性挖矿池注资，该池是 C.R.A.N.N.I 生态系统的去中心化流动性管理机制，以稳定币奖励用户的参与。该池的资金来自每张彩票的 4%（购买者有推荐人时为 3%）以及每一轮 Bull vs Bear、每一笔 BullsEye 投注和每一笔 Cranni Bestiarium 投注的 3%，因此用户可通过在 DEX 上为 CRANNI-WPOL 资金池提供流动性并质押其 LP 代币，分享 <strong>LUCKBLOCKS</strong> 的收入。不铸造任何代币：奖励仅来自已收取的费用，在约 7 天内逐区块释放，并随平台活跃度而变化。更多信息请见：<a href=\"https://docs.luckblocks.com/\">https://docs.luckblocks.com/</a> - 彩票 5% 折扣。在同一笔交易中购买 10 张或以上彩票，可享受总费用 5% 的折扣；如您持有 888 枚 CRANNI，总折扣可达 25%，这意味着您可以从抽奖奖金中获得更佳回报。"
    },
    {
      "tag": "p",
      "html": "<strong>10. 知识产权</strong>"
    },
    {
      "tag": "p",
      "html": "10.1 用户确认，<strong>LUCKBLOCKS</strong> 拥有 <strong>LUCKBLOCKS</strong> 网站、产品和服务中所使用的，或 <strong>LUCKBLOCKS</strong> 所创作或提供的任何材料中所使用的全部知识产权。此类知识产权包括但不限于：(a) 商标、公司名称、服务名称、标语、商业外观、标识、互联网域名及其他显著标志，以及所有相关申请、注册、延期和续展；(b) 专利、专利申请及所有相关续展、实用新型、实用新型申请、补充证书、补充证书申请、相关延期和续展，以及发明记录；(c) 工业设计注册和工业设计注册申请、相关延期和续展；(d) 映射；(e) 电路布图；(f) 著作权、计算机程序、版面布局、呈现形式、色彩组合、源代码及相关注册和申请；(g) 商业秘密和专有技术。"
    },
    {
      "tag": "p",
      "html": "10.2 用户同意不全部或部分侵犯、复制、模仿 <strong>LUCKBLOCKS</strong> 的任何知识产权，亦不将 <strong>LUCKBLOCKS</strong> 的任何知识产权用于本条款规定及法律允许范围以外的任何目的。"
    },
    {
      "tag": "p",
      "html": "10.3 <strong>LUCKBLOCKS</strong> 所提供的许可仅旨在使用户能够按照本条款允许的方式使用并享受所提供服务的利益，用户必须按此遵守，任何变更均以默示方式告知。"
    },
    {
      "tag": "p",
      "html": "<strong>11. 隐私</strong>"
    },
    {
      "tag": "p",
      "html": "11.1 <strong>LUCKBLOCKS</strong> 的隐私政策说明了您在使用我们的服务时，您的个人数据将如何被处理以及您的隐私将如何受到保护。使用我们的服务，即表示您同意 <strong>LUCKBLOCKS</strong> 可依据我们的隐私政策使用此类数据。"
    },
    {
      "tag": "p",
      "html": "11.2 <strong>LUCKBLOCKS</strong> 可为处理、存储和分析目的与第三方共享您的数据，但严格限于为实现使用 <strong>LUCKBLOCKS</strong> 网站进行的交易。"
    },
    {
      "tag": "p",
      "html": "11.3 <strong>LUCKBLOCKS</strong> 所使用界面的一份副本托管于星际文件系统（“IPFS”），这是一种去中心化、分布式的网络协议，以点对点方式存储和检索文件，使用分布式计算机网络而非依赖中央服务器。这意味着界面上的文件并非存储于单一位置，而是分布在 IPFS 网络内的多个节点上。"
    },
    {
      "tag": "p",
      "html": "11.4 您理解，界面的该副本托管于一个用于存储和访问数据及内容的去中心化基础设施，即 IPFS 上。"
    },
    {
      "tag": "p",
      "html": "<strong>12. LUCKBLOCKS 网站及使用条款的修改</strong>"
    },
    {
      "tag": "p",
      "html": "12.1 <strong>LUCKBLOCKS</strong> 可单方面修改本条款或适用于本服务的任何附加条款和政策，以反映法律变化或服务变更。用户有责任查阅相关条款和政策。在适用情况下，我们将在官方渠道发布有关附加条款的变更通知。变更将在其公告所示期限内生效。涉及本服务新功能的变更或出于法律原因作出的变更将立即生效。"
    },
    {
      "tag": "p",
      "html": "12.2 <strong>LUCKBLOCKS</strong> 亦可随时通过增加新服务和新产品扩展 <strong>LUCKBLOCKS</strong> 网站的用途，或停止提供某些产品或服务。"
    },
    {
      "tag": "p",
      "html": "<strong>13. 一般规定</strong>"
    },
    {
      "tag": "p",
      "html": "13.1 用户声明，其对在 <strong>LUCKBLOCKS</strong> 网站上进行的全部操作承担民事和刑事责任，并声明通过本网站进行交易所使用的资金来源合法。严禁将本网站用于洗钱、逃汇等犯罪行为，用户不仅可能对有关当局承担民事和刑事责任，且不影响其对 <strong>LUCKBLOCKS</strong> 所造成的任何损失和损害承担责任。"
    },
    {
      "tag": "p",
      "html": "13.2 用户声明其具备操作 <strong>LUCKBLOCKS</strong> 所提供服务的充分知识，不存在任何可能构成其在此方面处于弱势地位的疑问或事实，具有完全民事行为能力，并能够实施确保操作有效所需的任何行为。"
    },
    {
      "tag": "p",
      "html": "13.3 <strong>LUCKBLOCKS</strong> 不对因技术错误、故障、互联网连接中断或类似情况导致的任何直接或间接利润损失、数据丢失或损害承担责任。"
    },
    {
      "tag": "p",
      "html": "13.4 如本条款与附加条款之间存在冲突，就该冲突而言，以附加条款为准。"
    },
    {
      "tag": "p",
      "html": "13.5 本条款管辖 <strong>LUCKBLOCKS</strong> 与用户之间的关系，不为任何第三方创设任何权利。"
    },
    {
      "tag": "p",
      "html": "13.6 如因税务、监管、经济或任何其他相关立法的变化而发生的事件实质性改变本条款所规定的用户或 <strong>LUCKBLOCKS</strong> 的义务，本条款所约定的条件将予以复审。"
    },
    {
      "tag": "p",
      "html": "13.7 双方选定 <strong>帕劳 (PALAU)</strong> 的司法管辖区解决因本条款引起的任何疑问或争议。"
    },
    {
      "tag": "p",
      "html": "如需了解如何联系 <strong>LUCKBLOCKS</strong>，请访问网站 www.luckblocks.com 或联系服务渠道。"
    }
  ]
};

export default terms;
